import * as TypesUser from '../types/types_user'
import Vue from 'vue'
import jsCookie from 'js-cookie'
export default {
  state: {
    isLogin: false,
    userInfo: {},
    paymentInfo: {},
    schoolConfig: {}
  },
  mutations: {
    [TypesUser.USER_SET_INFO] (state, payload) {
      state.userInfo = payload || {}
      let payloadObj = payload || {}
      if (payloadObj.roleType === 1) {
        payloadObj.appId = 'wxfwh_xs'
      } else if (payloadObj.roleType === 2) {
        payloadObj.appId = 'wxfwh_jz'
      } else {
        payloadObj.appId = ''
      }
      window.trackInfo = payloadObj
    },
    [TypesUser.USER_SET_SCHOOL_CONFIG] (state, payload) {
      // 获取学校配置
      state.schoolConfig = payload || {}
    }
  },
  actions: {
    // 获取微信中URL的code
    [TypesUser.USER_GET_WECHAT_CODE] (ctx, url) {
      if (url.indexOf('code=') === -1) {
        // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        //   feConfig.appId
        //   }&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
      }
    },
    /**
     * 获取用户信息
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E8%8E%B7%E5%8F%96%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF%EF%BC%88%E7%BB%91%E5%AE%9A%E5%B8%90%E5%8F%B7%E9%A1%B5%E9%9D%A2%E5%B7%B2%E7%BB%91%E5%AE%9A%E6%83%85%E5%86%B5%EF%BC%89
     */
    [TypesUser.USER_GET_INFO] (ctx) {
      return Vue.http.get('/v1/accounts/user-info').then(function (resp) {
        // debugger
        return Vue.checkResp(resp)
      }).then(data => {
        ctx.commit(TypesUser.USER_SET_INFO, data)
        return data
      }).catch(err => {
        // 统一错误处理
        ctx.commit(TypesUser.USER_SET_INFO, null)
        throw err
      })
    },
    /**
     * 登陆微信
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E7%99%BB%E5%BD%95%E5%BE%AE%E4%BF%A1%EF%BC%88%E6%A0%B9%E6%8D%AEcode%E8%8E%B7%E5%8F%96cookie%E7%AD%89%E5%B8%90%E5%8F%B7%E4%BF%A1%E6%81%AF%EF%BC%89
     */
    [TypesUser.USER_GET_INFO_BY_CODE] (ctx, code) {
      return Vue.http.get('/v1/accounts/user-link', { params: { code } }).then(data => {
        ctx.commit(TypesUser.USER_SET_INFO, data)
        return data
      }).catch(err => {
        ctx.commit(TypesUser.USER_SET_INFO, null)
        throw err
      })
    },
    /**
     * 发送找回密码短信
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E5%8F%91%E9%80%81%E6%89%BE%E5%9B%9E%E5%AF%86%E7%A0%81%E9%AA%8C%E8%AF%81%E7%9F%AD%E4%BF%A1%EF%BC%88%E5%AF%86%E7%A0%81%E6%89%BE%E5%9B%9E%E6%89%8B%E6%9C%BA%EF%BC%89
     */
    [TypesUser.USER_SEND_PASSWORD_MSG] (ctx, postData) {
      return Vue.http.post('/v1/be-proxy/v2/users/retrieving-msg-code-with-captcha', postData)
        .then(resp => Vue.checkResp(resp))
        .then(data => data)
    },
    /**
     * 验证找回密码验证短信
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E9%AA%8C%E8%AF%81%E6%89%BE%E5%9B%9E%E5%AF%86%E7%A0%81%E9%AA%8C%E8%AF%81%E7%9F%AD%E4%BF%A1-%E9%AA%8C%E8%AF%81%E9%AA%8C%E8%AF%81%E7%A0%81
     */
    [TypesUser.USER_VERIFY_PASSWORD] (ctx, { phoneNumber, roleType, retrievingMsgCode }) {
      return Vue.http.post('/v1/be-proxy/v2/users/retrieving-msg-token', {
        phoneNumber,
        roleType,
        retrievingMsgCode
      }).then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    /**
     * 找回密码-验证&设置新密码
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E6%89%BE%E5%9B%9E%E5%AF%86%E7%A0%81-%E9%AA%8C%E8%AF%81&%E8%AE%BE%E7%BD%AE%E6%96%B0%E5%AF%86%E7%A0%81
     */
    [TypesUser.USER_RESET_PASSWORD] (ctx, { retrievingToken, password }) {
      return Vue.http.put('/v1/be-proxy/v2/users/forgot-password', {
        retrievingType: 2,
        retrievingToken,
        password
      }).then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    /**
     * 匹配学生信息，根据 姓名 & 考生号/学籍号/学号 获取对应学生
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E5%8C%B9%E9%85%8D%E5%AD%A6%E7%94%9F%E4%BF%A1%E6%81%AF%EF%BC%8C%E6%A0%B9%E6%8D%AE%E5%A7%93%E5%90%8D&%E8%80%83%E7%94%9F%E5%8F%B7/%E5%AD%A6%E7%B1%8D%E5%8F%B7/%E5%AD%A6%E5%8F%B7%E8%8E%B7%E5%8F%96%E5%AF%B9%E5%BA%94%E5%AD%A6%E7%94%9F%EF%BC%88%E7%94%A8%E4%BA%8E%E9%AA%8C%E8%AF%81%E5%AD%A6%E7%94%9F%E6%98%AF%E5%90%A6%E5%AD%98%E5%9C%A8%E5%8F%8A%E8%8E%B7%E5%8F%96%E5%AD%A6%E7%94%9FID%EF%BC%89
     */
    [TypesUser.USER_MATCH_STUDENTS] (ctx, { roleType, studentName, identityCode }) {
      return Vue.http.get('/v1/be-proxy/v2/users/matched-students', {
        params: { roleType, studentName, identityCode }
      }).then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    // http://wiki.iyunxiao.com/pages/viewpage.action?pageId=16908963#id-%E8%87%AA%E4%B8%BB%E6%B3%A8%E5%86%8C%E7%94%A8%E6%88%B7%E6%B3%A8%E5%86%8C%E6%BF%80%E6%B4%BBAPI-%E5%9F%BA%E4%BA%8E%E6%9F%90%E4%B8%80%E4%B8%AA%E8%99%9A%E6%8B%9F%E5%AD%A6%E7%94%9F%E7%BB%91%E5%AE%9A%E7%9C%9F%E5%AE%9E%E5%AD%A6%E7%94%9F
    // 虚拟学生绑定真实学生
    [TypesUser.USER_BIND_REAL_STUDENT] (ctx, params) {
      return Vue.http.post('/v1/be-proxy/v2/native-users/bind-real-student',
        params
      ).then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    /**
     * 绑定学生档案
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E7%BB%91%E5%AE%9A%E5%AD%A6%E7%94%9F
     */
    [TypesUser.USER_BIND_STUDENT] (ctx, params) {
      return Vue.http.put('/v1/be-proxy/v2/users/bind-student', params).then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    /**
     * 获取图片验证码
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E8%8E%B7%E5%8F%96%E5%9B%BE%E7%89%87%E9%AA%8C%E8%AF%81%E7%A0%81
     */
    [TypesUser.USER_GET_CAPTCHA] (ctx, params) {
      return Vue.http.get('/v1/be-proxy/v2/users/captcha', { params })
        .then(resp => Vue.checkResp(resp))
        .then(data => data)
    },
    // 上传微信埋点统计
    [TypesUser.USER_POST_TRACK_POINT] (ctx, params) {
      return Vue.http.post('/v1/be-proxy/v2/track-point', params)
        .then(resp => Vue.checkResp(resp))
        .then(data => data)
    },
    // 获取学校配置
    [TypesUser.USER_GET_SCHOOL_CONFIG] (ctx) {
      let schoolConfig = ctx.state.schoolConfig
      if (!Object.keys(schoolConfig).length) {
        return Vue.http.get('/v1/config/school').then(resp => {
          return Vue.checkResp(resp)
        }).then(data => {
          ctx.commit(TypesUser.USER_SET_SCHOOL_CONFIG, data)
          return data
        }).catch(err => {
          // 统一错误处理
          ctx.commit(TypesUser.USER_SET_SCHOOL_CONFIG, null)
          throw err
        })
      } else {
        return Promise.resolve(schoolConfig)
      }
    },
    // 支付取消或失败时调用
    [TypesUser.USER_DEL_PAYMENT] (ctx, paymentId) {
      return Vue.http.delete(`/v1/be-proxy/v2/payments/${paymentId}`).then(resp => {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    // 支持运营千万注册接口
    [TypesUser.USER_ENROLL] (ctx, params) {
      return Vue.http.post('/v1/messages/enroll', params).then(resp => {
        return Vue.checkResp(resp)
      }).then(data => {
        return { msg: '报名成功' }
      }).catch(err => {
        return err
      })
    }
  },
  getters: {
    ifLogin () {
      // 根据cookie判断；
      return !!jsCookie.get(feConfig.cookie)
    },
    // 屏蔽状态的设定 有三种状态，
    // 1.未登录与学生账号一致， 会员购买等不展示；
    // 2.家长账号但未配置屏蔽，会员购买等正常展示；
    // 3.家长账号且配置屏蔽， 会员购买等调整隐藏或显示已领取
    isShield: (state, getters, rootState) => {
      return !getters.ifLogin || state.userInfo.roleType === 1
    },
    isParentShield: state => {
      return state.userInfo.roleType === 2 && state.schoolConfig.parentPay === 1
    },
    isParentUnShield: state => {
      return state.userInfo.roleType === 2 && state.schoolConfig.parentPay === 2
    },
    currentUrl () {
      return sessionStorage.getItem('hfs-wechat-current-url') || document.URL
    },
    getSchoolConfig: state => examId => {
      // 判断examConfig存在,
      const examConfigs =
        (state.schoolConfig && state.schoolConfig.examConfigs) || []
      const globalConfig = state.schoolConfig || {}

      if (!examId) return globalConfig

      let config = examConfigs.find(g => Number(g.examId) === Number(examId))
      // 如果有examId,优先使用examConfig,没有考试则使用全局配置
      let resultConfig = config || globalConfig
      resultConfig.rankDegree = globalConfig.rankDegree
      if (!resultConfig.score) {
        resultConfig.score = 2 // 默认为未屏蔽 2
      }
      return resultConfig || {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_user.js